import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Config } from 'datatables.net';
import { Subject } from 'rxjs';
import { TravelCommissionsService } from 'src/app/services/travel-commissions.service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-travel-commissions',
  templateUrl: './travel-commissions.component.html',
  styleUrls: ['./travel-commissions.component.css'],
})
export class TravelCommissionsComponent implements OnInit {
  constructor(private service: TravelCommissionsService) {}

  role: string;

  // configs
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
  };
  dtTrigger: Subject<any> = new Subject<any>();
  maxDateForPicker: Date;

  month = '';
  @ViewChild('inputFile') myInputVariable: ElementRef;
  file: File | null = null;

  data = [];

  title = 'Travel Commissions';
  pdfSrc: string | ArrayBuffer | null = null;

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Travel Commissions');
    },100)
    this.role = sessionStorage.getItem('role');

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    this.maxDateForPicker = new Date(currentYear, currentMonth + 1);

    this.getTravelCommissions();
  }

  add() {
    $('#basicModal1').modal('show');
  }

  submit() {
    if (this.month && this.file) {
      const date = new Date(this.month);
      const year = date.getFullYear();
      const _month = String(date.getMonth() + 1).padStart(2, '0');

      this.service
        .postTravelCommissions(`${year}-${_month}`, this.file)
        .subscribe({
          next: (res: any) => {
            if (res) {
              this.getTravelCommissions();
              this.reset();
              $('#basicModal1').modal('hide');
            }
          },
          error: (error) => {
            console.log(error);
          },
        });
    }
  }

  reset() {
    this.month = '';
    this.file = null;
    this.myInputVariable.nativeElement.value = '';
  }

  viewPdf(item: any) {
    this.pdfSrc = undefined;
    this.title = '';

    this.service.downloadPdf(item.id).subscribe({
      next: (res: any) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        const fileReader = new FileReader();
        fileReader.onload = () => {
          this.pdfSrc = fileReader.result;
        };
        fileReader.readAsArrayBuffer(blob);

        this.title = `${item.name}`;
        $('#advisor-report-modal').modal('show');
      },
      error: (error) => {},
    });
  }

  deleteItem(id: number) {
    Swal.fire({
      title: 'Confirmation',
      text: `Are you sure you want to delete this record?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Confirmation',
          text: `Just to confirm, do you really want to delete this? Totally fine if you change your mind!`,
          showCancelButton: true,
          confirmButtonText: 'Yes',
        }).then((result) => {
          if (result.isConfirmed) {
            this.service.deleteTravelCommissions(id).subscribe({
              next: (res: any) => {
                this.getTravelCommissions();
              },
              error: (error) => {
                console.log(error);
              },
            });
          }
        });
      }
    });
  }

  // server functions
  getTravelCommissions() {
    this.service.getTravelCommissions().subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          $('#DataTables_Table_1').dataTable().fnDestroy();
          this.data = res;
          this.dtTrigger.next(null);
        } else {
          $('#DataTables_Table_1').dataTable().fnDestroy();
          this.data = [];
          this.dtTrigger.next(null);
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  // events
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.file = file;
    }
  }
}
